<template>
  <div>
    <p>{{$t('loginOut.loggedOutText')}}</p>
    <router-link to="/portal/login">{{$t('loginOut.loginButton')}}</router-link>
  </div>

</template>

<script>
import store from "@/store/store";

export default {
  name: "LoggedOut",
  mounted() {
    store.dispatch("Logout")
  }
}
</script>

<style scoped>

</style>